import UpgradeAccountToW8ContractModal from './UpgradeAccountToW8ContractModal';

export default UpgradeAccountToW8ContractModal;
